import { ENV_VARS } from '@/env';
import { Col, Row } from 'antd';
import { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { APP_ROUTES } from '../../../../../../contants/routes';
import {
  removeCurrentQuoteCarrier,
  resetCurrentQuoteCarrier,
  setCurrentQuoteCarriers,
} from '../../../../../../redux/common/CommonActions';
import { selectCurrentQuoteCarries } from '../../../../../../redux/common/CommonReducer';
import { resetSearchSpotQuoteBidders } from '../../../../../../redux/shipment/ShipmentActions';
import Button from '../../../../../components/Buttons/Button';
import PrimaryLabel from '../../../../../components/Labels/PrimaryLabel';
import Drawer from '../../../../../components/Modals/Drawer';
import ContentSpinner from '../../../../../components/Spinners/ContentSpinner';
import CollapsiblePanel from '../../../../../components/Tabs/CollapsiblePanel';
import HalBiddingLogDetailsCard from '../../../../Shipment/components/QuoteCard/components/Bidding/HalBiddingLogDetailsCard';
import HalBiddingLogHeader from '../../../../Shipment/components/QuoteCard/components/Bidding/HalBiddingLogHeader';
import BidDurationModal from '../../common/BidDurationModal';
import BiddingModal from '../../common/BiddingModal';

const isHalliburton = ENV_VARS.REACT_APP_THEME === 'halliburton';
const buttonClassName = isHalliburton ? 'hb-button' : '';

const QuoteBiddingLogs = () => {
  const [selectedBidders, setSelectedBidders] = useState([]);
  const [visible, setVisible] = useState(false);
  const [visibleBid, setVisibleBid] = useState(false);
  const [activeKey, setActiveKey] = useState([]);

  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const carriers = useSelector(selectCurrentQuoteCarries);
  const isCreateQuote = pathname === APP_ROUTES.SEARCH_QUOTE_CREATE;

  const handleTabClick = (keys) => {
    setActiveKey(keys);
  };

  const handleCloseDrawer = () => {
    setVisible(false);
    dispatch(resetSearchSpotQuoteBidders());
  };

  // Copy bids if it is a copy of a quote and if the status is right
  const { data = {} } = useSelector((state) => state.shipment.shipmentDetails);
  const copyQuoteKey = useSelector((state) => state.common.copyQuoteKey);
  const isCopiedQuote = Boolean(copyQuoteKey);

  useEffect(() => {
    dispatch(resetCurrentQuoteCarrier());
  }, [dispatch]);

  useEffect(() => {
    if (isCopiedQuote) {
      dispatch(
        setCurrentQuoteCarriers(
          data.biddings?.map((value) => ({
            carrierKey: value.carrierKey || value.carrierId,
            carrierName: value.carrierName || value.transportationProvider,
            routingGuideId: value.routingGuideId,
            email: value.emails,
          })),
        ),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCheckProvider = (_e, bidding) => {
    setSelectedBidders([bidding]);
  };

  const handleDeleteBidders = () => {
    const selectedBidder = selectedBidders[0]?.carrierKey || selectedBidders[0]?.carrierId;

    selectedBidder && dispatch(removeCurrentQuoteCarrier(selectedBidder));
    setSelectedBidders([]);
  };

  return (
    <div className="h-100 custom-scroll-bar ">
      <Row justify="end" align="middle">
        <Col className="px-15 py-10">
          <Row gutter={15}>
            <Col>
              <Drawer
                width="70%"
                visible={visibleBid}
                headerContents={<PrimaryLabel className="text-white">Bid Duration</PrimaryLabel>}
                onClose={() => setVisibleBid(false)}
              >
                <BidDurationModal />
              </Drawer>
            </Col>

            <Col>
              <Button dataTestId="quote-bidding-export-button" className={buttonClassName}>
                Export to Excel
              </Button>
            </Col>

            <Col>
              <Button
                dataTestId="quote-bidding-add-provider-button"
                className={buttonClassName}
                onClick={() => setVisible(true)}
              >
                Add Provider
              </Button>

              <Drawer
                width="60%"
                visible={visible}
                headerContents={<PrimaryLabel className="text-white">Transportation Provider Search</PrimaryLabel>}
                onClose={() => setVisible(false)}
              >
                <BiddingModal
                  createQuote={isCreateQuote}
                  onCloseModal={handleCloseDrawer}
                  spotQuoteBidders={carriers}
                />
              </Drawer>
            </Col>

            <Col>
              <Button
                disabled={selectedBidders.length === 0}
                dataTestId="quote-bidding-remove-provider-button"
                className={buttonClassName}
                onClick={handleDeleteBidders}
              >
                Remove Provider
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
      {carriers.progressing ? (
        <ContentSpinner size="large" />
      ) : (
        <div className="px-15 py-5">
          <CollapsiblePanel
            forceRender={false}
            handleTabClick={handleTabClick}
            activeKey={activeKey}
            tabs={carriers.map((carrier) => {
              return {
                header: (
                  <HalBiddingLogHeader
                    bidding={carrier}
                    selectedBidders={selectedBidders}
                    isCostBreakDown={false}
                    handleCheckProvider={handleCheckProvider}
                  />
                ),
                content: <HalBiddingLogDetailsCard bidding={carrier} />,
              };
            })}
          />
        </div>
      )}
    </div>
  );
};

export default memo(QuoteBiddingLogs);
